import React from "react";
import { Typography } from "@mui/material";

const sectionSubtitleSx = {
  fontSize: { xs: "1.25rem", md: "1.35rem" },
  fontWeight: 500,
  lineHeight: 1.35,
  mb: 1.2,
};

export default function SectionSubtitle({ children, sx = {}, ...props }) {
  return (
    <Typography
      variant="h5"
      sx={{ ...sectionSubtitleSx, ...sx }}
      {...props}
    >
      {children}
    </Typography>
  );
}

export const sectionSubtitleStyle = sectionSubtitleSx;
